import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import {
  GET_MCS_PLAY_BUTTON_LIST,
  GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES,
} from '../constants';
import api from './../../../../services/api/microfwk';
import { store } from 'store.js';
import { HttpClient } from 'api/helpers/HttpClient';
import { MULTI_CONTENT_SEARCH_PATH_SERVICES } from 'api/services/content/paths';
import { getContentListV1 } from 'utils/homologacion/homologacion';

//----UTILS----
const getMCSResponse = (contenidos, token) => {
  const claroAdsKey = getClaroAdsKey(store.getState())
  const extraParams = () => {
    let objResult = new Object();
    contenidos
      .filter(
        item =>
          item?.content_type === 'P' ||
          item?.content_type === 'S' ||
          item?.type === 'P' ||
          item?.type === 'S',
      )
      .map(item => {
        return (objResult[item?.id] = { format_types: getContentListV1?.marketingType(item) });
      });
    return objResult;
  };

  const data = new FormData();
  data.append('extra_params', JSON.stringify({ group_ids: extraParams() }));
  if(token && !claroAdsKey){
    data.append('token', `${token || ''}`);

  }
  const url = claroAdsKey ? MULTI_CONTENT_SEARCH_PATH_SERVICES : 'services/payway/paymentservice/multicontentsearch'
  const apiCall = new HttpClient({ hasClaroAdActive: claroAdsKey });


  return apiCall.post(url, data);
};

//Obtiene los permisos de reproduccion de los resultados de busqueda
export const getMCSPlayButtonList = (contenidos, token) => async dispatch => {
  try {
    const { data: purchaseResponse } = await getMCSResponse(contenidos, token);

    dispatch({
      type: GET_MCS_PLAY_BUTTON_LIST,
      payload: purchaseResponse?.data,
    });
  } catch (error) {}
};

//Obtiene los permisos de reproduccion de las busquedas populares
export const getPlayButtonListPopularSearches = (
  popular,
  token,
) => async dispatch => {
  try {
    const { data: purchaseResponse } = await getMCSResponse(popular, token);

    dispatch({
      type: GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES,
      payload: purchaseResponse?.data,
    });
    localStorage.setItem(
      'playPopularButtonListSaved',
      JSON.stringify(purchaseResponse?.data),
    );
  } catch (error) {
    if (localStorage.getItem('playPopularButtonListSaved')) {
      dispatch({
        type: GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES,
        payload: JSON.parse(localStorage.getItem('playPopularButtonListSaved')),
      });
    }
  }
};
